import { CrownOutlined, UserOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryIndicatorsSlider } from 'components/ui';
import { useVerificationFormStore } from 'stores/local';

import { ChooseSwitch } from './ChooseSwitch';
import s from './Header.module.scss';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const store = useVerificationFormStore();

  const handleSwitchChange = React.useCallback(() => {
    store.handleSwitchChange();
  }, [store]);

  return (
    <div className={s['header']}>
      <div className={s['header__left']}>
        <Typography.Text type="secondary">
          {t('verification.switchBoxHeader')}
        </Typography.Text>
        <ChooseSwitch
          className={s['header__left-switch']}
          trueDisplayLabel={t('verification.managerView')}
          falseDisplayLabel={t('verification.hrView')}
          checked={store.visibilityToggleModel.opened}
          onChange={handleSwitchChange}
          uncheckedChildren={<CrownOutlined />}
          checkedChildren={<UserOutlined />}
        />
      </div>

      <div className={s['header__right']}>
        <SummaryIndicatorsSlider
          fetching={
            store.tableStore.tableAggregationStore.aggregationRequest.loading
          }
          data={store.tableStore.tableAggregationStore.aggregationRow}
        />
      </div>
    </div>
  );
};

export default observer(Header);
